import AdvancedEditor from '@/pages/AdvancedEditor/AdvancedEditor';
import { AdvancedEditorContextProvider } from '@/pages/AdvancedEditor/context/AdvancedEditorContext';

export const AdvancedEditorPage = () => {
    return (
        <AdvancedEditorContextProvider>
            <AdvancedEditor />
        </AdvancedEditorContextProvider>
    );
};
